import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ENTITY_TABS } from "../../../../../utils/constants";
import { icons, sidebarIcons } from "../../icons/iconExport";

const LabelWithIcon = ({ type }) => {
  const style = {
    display: "flex",
    gap: 2,
    width: "100%",
    justifyContent: "flex-start",
  };
  switch (type) {
    case ENTITY_TABS.PROPERTIES:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.propertiesIcon} width={"14px"} />
          <Typography variant="body2">{ENTITY_TABS.PROPERTIES}</Typography>
        </Box>
      );
    case ENTITY_TABS.HISTORY:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.historyIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.HISTORY}</Typography>
        </Box>
      );
    case ENTITY_TABS.POLICIES:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.policiesIcon} width={"14px"} />
          <Typography variant="body2">{ENTITY_TABS.POLICIES}</Typography>
        </Box>
      );
    case ENTITY_TABS.GROUPS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.groupsIcon} width={"14px"} />
          <Typography variant="body2">{ENTITY_TABS.GROUPS}</Typography>
        </Box>
      );
    case ENTITY_TABS.MFA:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.mfaIcon} width={"18px"} />
          <Typography variant="body2">{ENTITY_TABS.MFA}</Typography>
        </Box>
      );
    case ENTITY_TABS.RISK:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.riskIcon} width={"14px"} />
          <Typography variant="body2">{ENTITY_TABS.RISK}</Typography>
        </Box>
      );
    case ENTITY_TABS.TAGS:
      return (
        <Box sx={style}>
          <SvgToIcon
            IconLogo={icons.tagsIcon}
            width={"12px"}
            style={{ marginLeft: "4px" }}
          />
          <Typography variant="body2">{ENTITY_TABS.TAGS}</Typography>
        </Box>
      );
    case ENTITY_TABS.VULNERABILITIES:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.cveIcon} width={"18px"} />
          <Typography variant="body2">{ENTITY_TABS.VULNERABILITIES}</Typography>
        </Box>
      );
    case ENTITY_TABS.PASSWORD_TRACKING:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.passwordTrackingIcon} width={"14px"} />
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
            {ENTITY_TABS.PASSWORD_TRACKING}
          </Typography>
        </Box>
      );
    case ENTITY_TABS.CONNECTED_HOSTS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.connectedHostsIcon} width={"14px"} />
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
            {ENTITY_TABS.CONNECTED_HOSTS}
          </Typography>
        </Box>
      );
    case ENTITY_TABS.ROLES:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.rolesIcon} width={"14px"} />
          <Typography variant="body2">{ENTITY_TABS.ROLES}</Typography>
        </Box>
      );
    case ENTITY_TABS.REPOSITORY:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.repositoryIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.REPOSITORY}</Typography>
        </Box>
      );
    case ENTITY_TABS.USERS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.userIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.USERS}</Typography>
        </Box>
      );
    case ENTITY_TABS.APPS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.appIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.APPS}</Typography>
        </Box>
      );
    case ENTITY_TABS.CREDENTIALS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.keyOriginIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.CREDENTIALS}</Typography>
        </Box>
      );
    case ENTITY_TABS.SECURITY_GROUPS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.securityGroupsIcon} width={"16px"} />
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
            {ENTITY_TABS.SECURITY_GROUPS}
          </Typography>
        </Box>
      );
    case ENTITY_TABS.ACTIVITY:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.activityIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.ACTIVITY}</Typography>
        </Box>
      );
    case ENTITY_TABS.LOGINS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.activityIcon} width={"16px"} />
          <Typography variant="body2">{ENTITY_TABS.LOGINS}</Typography>
        </Box>
      );
    case ENTITY_TABS.COMPLIANCE:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={sidebarIcons.UserAccessIcon} width={"12px"} />
          <Typography variant="body2">{ENTITY_TABS.COMPLIANCE}</Typography>
        </Box>
      );
    case ENTITY_TABS.CLASSIFICATION:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={sidebarIcons.TrackingIcon} width={"12px"} />
          <Typography variant="body2">{ENTITY_TABS.CLASSIFICATION}</Typography>
        </Box>
      );
    case ENTITY_TABS.OWNERSHIP:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.groupsIcon} width={"14px"} />
          <Typography variant="body2">{ENTITY_TABS.OWNERSHIP}</Typography>
        </Box>
      );
    case ENTITY_TABS.INSTALLED_PROGRAMS:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.appIcon} width={"14px"} />
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
            {ENTITY_TABS.INSTALLED_PROGRAMS}
          </Typography>
        </Box>
      );
    case ENTITY_TABS.RAW_DATA:
      return (
        <Box sx={style}>
          <SvgToIcon IconLogo={icons.jsonIcon} width={"14px"} />
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
            {ENTITY_TABS.RAW_DATA}
          </Typography>
        </Box>
      );
    default:
      return null;
  }
};

export default LabelWithIcon;
